package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import org.vreo.devicehub.features.core.domain.device.device.AnprDevice
import org.vreo.devicehub.features.core.domain.device.device.ProductType

import vreo.volt.protocol.DeviceConfiguration

/**
 * Map anpr device to device configuration proto-buf message
 *
 * @return device configuration proto-buf message
 */
fun AnprDevice.toDeviceConfigurationProto(): DeviceConfiguration {
    val connectionKey = this.primaryConnectionKey ?: throw IllegalArgumentException(
        "ANPR Device is missing primary connection key"
    )

    val password = this.linkinPassword ?: throw IllegalArgumentException(
        "ANPR Device is missing linking password"
    )

    return DeviceConfiguration(
        device = this.device.deviceType,
        model = this.device.model,
        serial_number = this.serialNumber,
        connection_key = connectionKey,
        password = password
    )
}

/**
 * Map device configuration proto-buf message to anpr device
 *
 * @return anpr device
 */
fun DeviceConfiguration.toAnprDevice(): AnprDevice {
    val device = ProductType.VALUES.firstOrNull {
        it.deviceType == this.device && it.model == this.model
    }

    if (device == null) {
        throw IllegalArgumentException(
            "ANPR device has invalid product type: ${this.device} ${this.model}"
        )
    }

    return AnprDevice(
        deviceId = "${device.deviceType}-${device.model}-${this.serial_number}",
        device = device,
        serialNumber = this.serial_number,
        softwareVersion = this.software_version,
        ocrVersion = this.ocr_version,
        localIpAddress = this.local_ip_address,
        macAddress = this.mac_address,
        active = true,
        userTag = null,
    )
}
